import { ActionReducerMap } from '@ngrx/store';
import { workspaceReducer, WorkspaceStoreState } from './workspace';
import { entitlementsReducer, EntitlementsState } from './entitlements';
import { automationDetailsReducer, AutomationDetailsState } from '@app/pages/dashboard/pages/automations/store';

export interface AppState {
  workspace: WorkspaceStoreState;
  entitlements: EntitlementsState;
  automationDetails: AutomationDetailsState;
  // Add other slices of state here as needed
}

export const reducers: ActionReducerMap<AppState> = {
  workspace: workspaceReducer,
  entitlements: entitlementsReducer,
  automationDetails: automationDetailsReducer,
  // Add other reducers here as needed
};
